import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, LoginSoapRequest } from './types';

// ACTIONS
import { loginSoapSuccess, loginSoapFailure } from './actions';

function* loginSoapRequest(request: ReducerAction) {
	const { payload }: { payload: LoginSoapRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`eportal/${CHANNEL}/logon`,
		payload,
	);

	if (response.status === 200 || response.status === 204) {
		yield put(loginSoapSuccess({ response, request: payload }));
	} else {
		yield put(loginSoapFailure(response));
	}
}

export default all([takeLatest(Types.LOGIN_SOAP_REQUEST, loginSoapRequest)]);
